import {
    onMounted,
} from "vue";
import { useAppState }                      from "../appState.js";
import {
    DefaultLocale,
    formatLocale,
    normalizeSupportedLocale,
    type SupportedLocale,
} from "@logscord/i18n";

export { formatLocale };

let LocaleRuntimeRegistered = false;

function getStoredLanguage() {
    if (typeof window === "undefined")
        return null;

    return localStorage["lang"] || null;
}

function getNavigatorLanguage() {
    if (typeof window === "undefined")
        return null;

    return navigator.languages?.[0] || navigator.language || null;
}

function getClientPreferredLanguage() {
    return normalizeSupportedLocale(getStoredLanguage() || getNavigatorLanguage() || DefaultLocale);
}

function persistResolvedLanguage(locale: SupportedLocale) {
    if (typeof document === "undefined")
        return;

    document.documentElement.lang = locale;
}


///////////////////////////////////////////
//  LOCALE
///////////////////////////////////////////


export function useLocale() {
    const appState = useAppState();

    function reconcileLanguage() {
        if (appState.localeLocked.value)
            return;

        const nextLocale = getClientPreferredLanguage();

        if (appState.locale.value !== nextLocale)
            appState.setLocale(nextLocale);

        persistResolvedLanguage(nextLocale);
    }

    function registerLocaleRuntime() {
        if (LocaleRuntimeRegistered)
            return;

        LocaleRuntimeRegistered = true;
        reconcileLanguage();

        window.addEventListener("languagechange", reconcileLanguage, { passive: true });
        window.addEventListener("storage", (event) => {
            if (event.key === "lang")
                reconcileLanguage();
        }, { passive: true });
    }

    onMounted(registerLocaleRuntime);

    return {
        locale: appState.locale,
        i18n(key: string, ...args: any[]) {
            return formatLocale(appState.locale.value, key, ...args);
        },
    };
}
